import styled from 'styled-components';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';

export default function TruckBanner() {
  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });

  // El camión entra desde la izquierda (fuera de pantalla) y avanza hacia la derecha
  const truckX = useTransform(scrollYProgress, [0, 0.4, 1], ['-55%', '0%', '30%']);
  const truckOpacity = useTransform(scrollYProgress, [0, 0.1, 0.85, 1], [0, 1, 1, 0]);

  return (
    <Section ref={ref}>
      <Track />
      <motion.div
        style={{ x: truckX, opacity: truckOpacity }}
        transition={{ type: 'tween' }}
      >
        <Truck
          src="/img/complements/camin_jaycom.png"
          alt="Camión Grupo Jaycom Tarimas"
        />
      </motion.div>
    </Section>
  );
}

const Section = styled.div`
  width: 100%;
  overflow: hidden;
  background: transparent;
  padding: 3rem 0 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const Track = styled.div`
  position: absolute;
  bottom: 2.8rem;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    var(--border) 10%,
    var(--border) 90%,
    transparent 100%
  );
`;

const Truck = styled.img`
  width: 100%;
  max-width: 1100px;
  display: block;
  user-select: none;
  pointer-events: none;
`;
